module.exports = __webpack_public_path__ + "img/icon-MAS.91f84243.svg";